import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { VideoRecorder } from '../components/VideoRecorder';
import { ArrowLeftIcon, VideoIcon, MicIcon, MessageSquareIcon } from 'lucide-react';
type ResponseType = 'video' | 'audio' | 'text';
export function ViewPrompt() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState<any>(null);
  const [responseType, setResponseType] = useState<ResponseType | null>(null);
  const [textResponse, setTextResponse] = useState('');
  const [showRecorder, setShowRecorder] = useState(false);
  useEffect(() => {
    const prompts = JSON.parse(localStorage.getItem('prompts') || '[]');
    const foundPrompt = prompts.find((p: any) => p.id === id);
    setPrompt(foundPrompt);
  }, [id]);
  const handleSaveResponse = (blob?: Blob) => {
    if (!prompt) return;
    const prompts = JSON.parse(localStorage.getItem('prompts') || '[]');
    const promptIndex = prompts.findIndex((p: any) => p.id === id);
    if (promptIndex !== -1) {
      const response = {
        id: Date.now().toString(),
        type: responseType,
        content: blob ? URL.createObjectURL(blob) : textResponse,
        createdAt: new Date().toISOString()
      };
      prompts[promptIndex].responses.push(response);
      localStorage.setItem('prompts', JSON.stringify(prompts));
      alert('Response submitted successfully!');
      navigate('/');
    }
  };
  if (!prompt) {
    return <div className="min-h-screen flex items-center justify-center text-white" data-id="element-98">
        <p data-id="element-99">Loading...</p>
      </div>;
  }
  return <div className="min-h-screen p-6 text-white" data-id="element-100">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-101">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-white/80 hover:text-white transition-colors" data-id="element-102">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-103" />
          Back
        </button>
        <div className="space-y-4" data-id="element-104">
          <h1 className="text-3xl font-bold" data-id="element-105">{prompt.title}</h1>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden" data-id="element-106">
          <div className="aspect-video bg-black" data-id="element-107">
            <video src={prompt.videoUrl} controls autoPlay className="w-full h-full" data-id="element-108" />
          </div>
        </div>
        {!responseType && <div className="space-y-4" data-id="element-109">
            <p className="text-lg font-medium" data-id="element-110">
              How would you like to respond?
            </p>
            <div className="grid sm:grid-cols-3 gap-4" data-id="element-111">
              <button onClick={() => {
            setResponseType('video');
            setShowRecorder(true);
          }} className="bg-white/20 backdrop-blur-sm p-6 rounded-xl hover:bg-white/30 transition-all flex flex-col items-center gap-3" data-id="element-112">
                <VideoIcon className="w-8 h-8" data-id="element-113" />
                <span className="font-semibold" data-id="element-114">Video</span>
              </button>
              <button onClick={() => {
            setResponseType('audio');
            setShowRecorder(true);
          }} className="bg-white/20 backdrop-blur-sm p-6 rounded-xl hover:bg-white/30 transition-all flex flex-col items-center gap-3" data-id="element-115">
                <MicIcon className="w-8 h-8" data-id="element-116" />
                <span className="font-semibold" data-id="element-117">Audio</span>
              </button>
              <button onClick={() => setResponseType('text')} className="bg-white/20 backdrop-blur-sm p-6 rounded-xl hover:bg-white/30 transition-all flex flex-col items-center gap-3" data-id="element-118">
                <MessageSquareIcon className="w-8 h-8" data-id="element-119" />
                <span className="font-semibold" data-id="element-120">Text</span>
              </button>
            </div>
          </div>}
        {showRecorder && (responseType === 'video' || responseType === 'audio') && <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6" data-id="element-121">
              <VideoRecorder audioOnly={responseType === 'audio'} onSave={handleSaveResponse} onCancel={() => {
          setShowRecorder(false);
          setResponseType(null);
        }} data-id="element-122" />
            </div>}
        {responseType === 'text' && !showRecorder && <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 space-y-4" data-id="element-123">
            <textarea value={textResponse} onChange={e => setTextResponse(e.target.value)} placeholder="Type your response here..." rows={6} className="w-full px-4 py-3 rounded-lg bg-white/20 backdrop-blur-sm border border-white/30 text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 resize-none" data-id="element-124" />
            <div className="flex gap-4" data-id="element-125">
              <button onClick={() => setResponseType(null)} className="flex-1 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-xl font-semibold hover:bg-white/30 transition-all" data-id="element-126">
                Cancel
              </button>
              <button onClick={() => handleSaveResponse()} disabled={!textResponse.trim()} className="flex-1 bg-white text-rose-500 px-6 py-3 rounded-xl font-semibold hover:bg-opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-127">
                Submit Response
              </button>
            </div>
          </div>}
      </div>
    </div>;
}